// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__Ujy14","position":"style_position__mB90+"};